<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-phone`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 2c1.105 0 2 .9 2 2v20.032a9.882 9.882 0 00-4 .5V6H8v36h10.143a8.87 8.87 0 001.805 4H6c-1.105 0-2-.9-2-2V4c0-1.1.895-2 2-2h28zM20 33c.498 0 .968.121 1.381.336-1.57 1.2-2.721 2.992-3.172 5.07A3 3 0 0120 33zm3-22l.117.007A1 1 0 0124 12v2l-.007.117A1 1 0 0123 15h-6l-.117-.007A1 1 0 0116 14v-2l.007-.117A1 1 0 0117 11h6zm11.902 17c4.059 0 7.403 3.15 7.855 7.204C44.67 36.086 46 38.061 46 40.357c0 3.093-2.416 5.604-5.41 5.643H28.035C24.702 46 22 43.218 22 39.786c0-3.206 2.358-5.845 5.385-6.179C28.42 30.352 31.395 28 34.902 28zm0 4c-1.674 0-3.17 1.135-3.705 2.819l-.788 2.479-2.586.285c-1.005.11-1.823 1.042-1.823 2.203 0 1.248.938 2.214 2.035 2.214h12.503c.783-.01 1.462-.717 1.462-1.643 0-.684-.377-1.27-.918-1.52l-2.05-.946-.25-2.244C38.549 33.558 36.864 32 34.902 32z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudPhone',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
